import  React from 'react';

const HomeSeparator = (props) => <div className={`img-separator ${props.className? props.className :''}`} ></div>
export default HomeSeparator;